export default class scroll {
    constructor(manager,scene) {

        //manager
        this.manager = manager;
        this.sceneManager = scene;

    }
    renderIndex(){

        // if(this.manager.param.displayType != 'sp') return;
        this.num = this.manager.param.displayType === 'sp' ? 50 : 150

        if(this.num<=this.manager.scroll.nowInc){
            if(this.sceneManager.status.titleFlg) return;
            this.sceneManager.status.titleFlg = true;
            TweenLite.to(this.sceneManager.$title,.6,{
                opacity:0,
                y:-20,
                ease: Power2.easeOut,
            });
        }else{
            if(!this.sceneManager.status.titleFlg) return;
            this.sceneManager.status.titleFlg = false;
            TweenLite.to(this.sceneManager.$title,.6,{
                opacity:1,
                y:0,
                ease: Power2.easeOut,
            });
        }

    }
    resizeIndex(){

        let _rect =  this.sceneManager.$scrollList[0].getBoundingClientRect();
        this.sceneManager.status.titlePoint = (_rect.top + this.manager.scroll.nowInc) - 170;

    }
}